/*
 * Shop dropdown: full-width panel with the "New In" / "Categories" text
 * columns on the left and promo photos on the right (custom-header.css
 * handles the column widths, the 4:5 tile sizing, and the flex layout - the
 * two-column-with-headers shape itself is the theme's own built-in
 * mega-menu layout, applied automatically now that "Shop" nests its links
 * two levels deep in Shopify Admin > Navigation).
 *
 * Same positioning approach as the Discover dropdown
 * (custom-discover-scroll.js): the theme's own dropdown panel is
 * position:absolute relative to the "Shop" <li> (only as wide as that
 * link), so it can't span the header width on its own. This switches it to
 * position:fixed and sets left/width/top in JS to match the header's full
 * width, on every open/resize.
 *
 * It also keeps the promo tiles short enough to fit on screen. They're 4:5
 * portrait (custom-header.css), so growing them to fill the row's width
 * would often run the bottom of the photos off the bottom of the viewport,
 * forcing a scroll just to see them fully. Instead, on every open/resize
 * this measures the actual space between the header and the bottom of the
 * viewport and writes that as a --shop-tile-max-w custom property, which
 * custom-header.css uses as the tiles' max-width - so the tiles size
 * themselves to whatever fits, on any screen, rather than to one fixed
 * guess. The clamp range here is deliberately smaller than the old
 * single-column layout's, since Tony wants the photos noticeably smaller
 * now that a second text column ("New In") sits in the row too.
 *
 * Scoped entirely to [data-menu-handle="shop"] - no other dropdown is
 * touched, and nothing here changes shared markup in nav-call-to-action.liquid.
 */
(function () {
  var GUTTER = 24;
  var VERTICAL_PADDING = 56;
  var BOTTOM_MARGIN = 24;
  var TILE_RATIO = 4 / 5;
  var MIN_TILE_WIDTH = 160;
  var MAX_TILE_WIDTH = 300;

  function setup(ul) {
    if (ul.dataset.shopMenuInit) return;
    ul.dataset.shopMenuInit = '1';

    var li = ul.closest('li');

    function positionRow() {
      var anchorBottom = li ? li.getBoundingClientRect().bottom : 0;
      ul.style.left = GUTTER + 'px';
      ul.style.width = (window.innerWidth - GUTTER * 2) + 'px';
      ul.style.top = anchorBottom + 'px';

      var availableHeight = window.innerHeight - anchorBottom - VERTICAL_PADDING - BOTTOM_MARGIN;
      var maxTileWidth = Math.max(MIN_TILE_WIDTH, Math.min(MAX_TILE_WIDTH, availableHeight * TILE_RATIO));
      ul.style.setProperty('--shop-tile-max-w', maxTileWidth + 'px');
    }

    positionRow();
    window.addEventListener('resize', positionRow);

    if (li) {
      li.addEventListener('mouseenter', function () {
        positionRow();
        setTimeout(positionRow, 50);
      });
      li.addEventListener('focusin', positionRow);
    }

    var tries = 0;
    var poll = setInterval(function () {
      positionRow();
      tries += 1;
      if (tries > 15) clearInterval(poll);
    }, 200);
  }

  function init() {
    var ul = document.querySelector('.tier-1 ul[data-menu-handle="shop"]');
    if (ul) setup(ul);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
